var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXenonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 239.044,
    height: 70.377,
    viewBox: "0 0 239.044 70.377",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0.561,
    width: 63.158,
    height: 69.703,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3e00f8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 0,
    y: 0.561,
    width: 63.158,
    height: 69.703,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3f10cd",
    result: "e"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "e"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    x: 43.651,
    y: 0.359,
    width: 57.722,
    height: 69.905,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "g"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3e00f8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "g"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    x: 43.651,
    y: 0.359,
    width: 57.722,
    height: 69.905,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "i"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3f10cd",
    result: "j"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "i"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "j"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    x: 81.404,
    y: 0.561,
    width: 63.259,
    height: 69.703,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "l"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3e00f8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "l"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "m",
    x: 81.404,
    y: 0.561,
    width: 63.259,
    height: 69.703,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "n"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3f10cd",
    result: "o"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "n"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "o"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "p",
    x: 125.055,
    y: 0,
    width: 70.42,
    height: 70.377,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "q"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3e00f8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "q"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "r",
    x: 125.055,
    y: 0,
    width: 70.42,
    height: 70.377,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "s"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3f10cd",
    result: "t"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "s"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "t"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "u",
    x: 175.785,
    y: 0.561,
    width: 63.259,
    height: 69.703,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "v"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3e00f8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "v"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "w",
    x: 175.785,
    y: 0.561,
    width: 63.259,
    height: 69.703,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "x"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3f10cd",
    result: "y"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "x"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "y"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.857 16.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.357 0)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16.5, -16.5)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.419.782h-.5a1.234,1.234,0,0,0-.834.324,15.677,15.677,0,0,0-2.368,2.783c-7.022,8.3-9.071,10.859-9.668,11.87C12.583,12.68,9.708,9.09,6.353,4.9,3.792,1.487,3.022.978,2.5.77a1.234,1.234,0,0,0-.46-.089,2.151,2.151,0,0,0-1.9,1.356A1.245,1.245,0,0,0,0,2.622v.2a1.237,1.237,0,0,0,.268.769c5.222,6.574,9.211,11.589,12.264,15.419a1.154,1.154,0,0,0-.138.106c-.3.271-1.018.906-12.139,15.372A1.235,1.235,0,0,0,0,35.243v.3a1.232,1.232,0,0,0,.17.625A2.623,2.623,0,0,0,1.493,37.3a1.242,1.242,0,0,0,.447.083h.2a1.232,1.232,0,0,0,.671-.2c.5-.322,1.421-1.228,4.731-5.609,4.824-6.129,6.637-8.551,7.357-9.6,5.494,6.88,7.012,8.729,7.5,9.275h0c4.623,6.13,4.988,6.13,5.719,6.13a2.2,2.2,0,0,0,1.833-1.154,1.237,1.237,0,0,0,.208-.686v-.1a2.081,2.081,0,0,0-.294-1.068c-.094-.148-.291-.456-12.611-15.859a1.232,1.232,0,0,0,.374-.167c.341-.228.913-.608,8.307-9.789,4.225-4.927,4.225-5.373,4.225-5.939v-.1a1.241,1.241,0,0,0-.247-.743,1.965,1.965,0,0,0-1.492-1",
    transform: "translate(16.5 16.38)",
    fill: "#e92efb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16.5, -16.5)",
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.419.782h-.5a1.234,1.234,0,0,0-.834.324,15.677,15.677,0,0,0-2.368,2.783c-7.022,8.3-9.071,10.859-9.668,11.87C12.583,12.68,9.708,9.09,6.353,4.9,3.792,1.487,3.022.978,2.5.77a1.234,1.234,0,0,0-.46-.089,2.151,2.151,0,0,0-1.9,1.356A1.245,1.245,0,0,0,0,2.622v.2a1.237,1.237,0,0,0,.268.769c5.222,6.574,9.211,11.589,12.264,15.419a1.154,1.154,0,0,0-.138.106c-.3.271-1.018.906-12.139,15.372A1.235,1.235,0,0,0,0,35.243v.3a1.232,1.232,0,0,0,.17.625A2.623,2.623,0,0,0,1.493,37.3a1.242,1.242,0,0,0,.447.083h.2a1.232,1.232,0,0,0,.671-.2c.5-.322,1.421-1.228,4.731-5.609,4.824-6.129,6.637-8.551,7.357-9.6,5.494,6.88,7.012,8.729,7.5,9.275h0c4.623,6.13,4.988,6.13,5.719,6.13a2.2,2.2,0,0,0,1.833-1.154,1.237,1.237,0,0,0,.208-.686v-.1a2.081,2.081,0,0,0-.294-1.068c-.094-.148-.291-.456-12.611-15.859a1.232,1.232,0,0,0,.374-.167c.341-.228.913-.608,8.307-9.789,4.225-4.927,4.225-5.373,4.225-5.939v-.1a1.241,1.241,0,0,0-.247-.743,1.965,1.965,0,0,0-1.492-1",
    transform: "translate(16.5 16.38)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16.5, -16.5)",
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.8,4.519a1.164,1.164,0,0,0,.12-.006A1.916,1.916,0,0,0,65.8,2.578,2.207,2.207,0,0,0,64.312.55,1.229,1.229,0,0,0,63.8.436H43.079a1.237,1.237,0,0,0-.4.074,1.97,1.97,0,0,0-1.12.756,1.781,1.781,0,0,0-.486,1.21c0,.035.007.064.008.1a1.274,1.274,0,0,0-.008.138V34.95c0,.046.008.083.01.128a1.2,1.2,0,0,0-.01.121,2.2,2.2,0,0,0,.355,1.2,1.931,1.931,0,0,0,1.686.942h.2c.016,0,.03-.007.047-.008.035,0,.063.008.1.008H63.411c1.762,0,2.387-1.1,2.387-2.042a1.961,1.961,0,0,0-2.1-2.041H45.058V20.93H63.22c1.9,0,2.578-1.107,2.578-2.142v-.1a1.239,1.239,0,0,0-.138-.568,2.338,2.338,0,0,0-2.153-1.272H45.058V4.519Z",
    transform: "translate(19.08 16.42)",
    fill: "#e92efb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16.5, -16.5)",
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.8,4.519a1.164,1.164,0,0,0,.12-.006A1.916,1.916,0,0,0,65.8,2.578,2.207,2.207,0,0,0,64.312.55,1.229,1.229,0,0,0,63.8.436H43.079a1.237,1.237,0,0,0-.4.074,1.97,1.97,0,0,0-1.12.756,1.781,1.781,0,0,0-.486,1.21c0,.035.007.064.008.1a1.274,1.274,0,0,0-.008.138V34.95c0,.046.008.083.01.128a1.2,1.2,0,0,0-.01.121,2.2,2.2,0,0,0,.355,1.2,1.931,1.931,0,0,0,1.686.942h.2c.016,0,.03-.007.047-.008.035,0,.063.008.1.008H63.411c1.762,0,2.387-1.1,2.387-2.042a1.961,1.961,0,0,0-2.1-2.041H45.058V20.93H63.22c1.9,0,2.578-1.107,2.578-2.142v-.1a1.239,1.239,0,0,0-.138-.568,2.338,2.338,0,0,0-2.153-1.272H45.058V4.519Z",
    transform: "translate(19.08 16.42)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16.5, -16.5)",
    filter: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.165.862a1.238,1.238,0,0,0-.44-.081A2.141,2.141,0,0,0,103.591,2.9a1.31,1.31,0,0,0-.009.15v26.7L83.759,4.9C81.2,1.487,80.428.978,79.906.77a1.218,1.218,0,0,0-.46-.089h-.1a1.238,1.238,0,0,0-.44.081,2.657,2.657,0,0,0-1.516,1.61,1.24,1.24,0,0,0-.085.451v32.42a1.244,1.244,0,0,0,.116.525,2.673,2.673,0,0,0,1.643,1.585,1.253,1.253,0,0,0,.282.032A2.074,2.074,0,0,0,81.257,36.2a1.24,1.24,0,0,0,.131-.553V8.355l20.121,25.106a31.058,31.058,0,0,0,2.433,3.008,1.891,1.891,0,0,0,1.248.871l.069.016a1.222,1.222,0,0,0,.263.028h.3a1.236,1.236,0,0,0,.8-.3,2.065,2.065,0,0,0,.936-1.513V2.934a2.134,2.134,0,0,0-1.4-2.072",
    transform: "translate(20.6 16.38)",
    fill: "#e92efb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16.5, -16.5)",
    filter: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.165.862a1.238,1.238,0,0,0-.44-.081A2.141,2.141,0,0,0,103.591,2.9a1.31,1.31,0,0,0-.009.15v26.7L83.759,4.9C81.2,1.487,80.428.978,79.906.77a1.218,1.218,0,0,0-.46-.089h-.1a1.238,1.238,0,0,0-.44.081,2.657,2.657,0,0,0-1.516,1.61,1.24,1.24,0,0,0-.085.451v32.42a1.244,1.244,0,0,0,.116.525,2.673,2.673,0,0,0,1.643,1.585,1.253,1.253,0,0,0,.282.032A2.074,2.074,0,0,0,81.257,36.2a1.24,1.24,0,0,0,.131-.553V8.355l20.121,25.106a31.058,31.058,0,0,0,2.433,3.008,1.891,1.891,0,0,0,1.248.871l.069.016a1.222,1.222,0,0,0,.263.028h.3a1.236,1.236,0,0,0,.8-.3,2.065,2.065,0,0,0,.936-1.513V2.934a2.134,2.134,0,0,0-1.4-2.072",
    transform: "translate(20.6 16.38)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16.5, -16.5)",
    filter: "url(#p)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.54,8.315l-.071-.071a1.229,1.229,0,0,0-.615-.335,1.843,1.843,0,0,0-1.739.336l-.232.231a1.219,1.219,0,0,0-.147.179l-.3.445a1.236,1.236,0,0,0-.025,1.351,22.78,22.78,0,0,1,2.015,4.1c1.434,6.016.248,10.822-3.565,14.639a13.113,13.113,0,0,1-3.6,2.5,14.91,14.91,0,0,1-9.8,1.367,16.5,16.5,0,0,1-6.131-2.893,1.241,1.241,0,0,0-.443-.471l-.339-.209-.36-.36a15.055,15.055,0,0,1-4.463-11.543c.513-3.873,1.745-6.808,3.662-8.724L128.5,7.732c2.124-2.123,5.215-3.378,9.19-3.729a17.731,17.731,0,0,1,7.034,1.518c.758.583,2.713,2,4.03.681l.232-.232a1.226,1.226,0,0,0,.169-.211,1.972,1.972,0,0,0,0-1.844,1.258,1.258,0,0,0-.263-.388,12.932,12.932,0,0,0-3.592-2.1A20.251,20.251,0,0,0,136.851.016l-.1.007A19.084,19.084,0,0,0,125.166,5.29a19.93,19.93,0,0,0-3.383,4.541,18.7,18.7,0,0,0-1.409,13.888c1.249,3.494,2.59,5.926,4.1,7.435a1.173,1.173,0,0,0,.123.109,1.278,1.278,0,0,0,.226.227,1.488,1.488,0,0,0,.114.128l.3.3a1.234,1.234,0,0,0,.11.1,1.252,1.252,0,0,0,.1.116c.026.026.055.052.084.077a1.02,1.02,0,0,0,.076.083c2.559,2.559,6.174,4.244,10.745,5.008a1.079,1.079,0,0,0,.117.014q.885.062,1.742.062a18.366,18.366,0,0,0,13.491-5.4c3.485-3.483,5.283-8.107,5.347-13.746a1.163,1.163,0,0,0-.009-.161c-.573-4.777-1.72-7.966-3.5-9.75",
    transform: "translate(21.92 16.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16.5, -16.5)",
    filter: "url(#r)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.54,8.315l-.071-.071a1.229,1.229,0,0,0-.615-.335,1.843,1.843,0,0,0-1.739.336l-.232.231a1.219,1.219,0,0,0-.147.179l-.3.445a1.236,1.236,0,0,0-.025,1.351,22.78,22.78,0,0,1,2.015,4.1c1.434,6.016.248,10.822-3.565,14.639a13.113,13.113,0,0,1-3.6,2.5,14.91,14.91,0,0,1-9.8,1.367,16.5,16.5,0,0,1-6.131-2.893,1.241,1.241,0,0,0-.443-.471l-.339-.209-.36-.36a15.055,15.055,0,0,1-4.463-11.543c.513-3.873,1.745-6.808,3.662-8.724L128.5,7.732c2.124-2.123,5.215-3.378,9.19-3.729a17.731,17.731,0,0,1,7.034,1.518c.758.583,2.713,2,4.03.681l.232-.232a1.226,1.226,0,0,0,.169-.211,1.972,1.972,0,0,0,0-1.844,1.258,1.258,0,0,0-.263-.388,12.932,12.932,0,0,0-3.592-2.1A20.251,20.251,0,0,0,136.851.016l-.1.007A19.084,19.084,0,0,0,125.166,5.29a19.93,19.93,0,0,0-3.383,4.541,18.7,18.7,0,0,0-1.409,13.888c1.249,3.494,2.59,5.926,4.1,7.435a1.173,1.173,0,0,0,.123.109,1.278,1.278,0,0,0,.226.227,1.488,1.488,0,0,0,.114.128l.3.3a1.234,1.234,0,0,0,.11.1,1.252,1.252,0,0,0,.1.116c.026.026.055.052.084.077a1.02,1.02,0,0,0,.076.083c2.559,2.559,6.174,4.244,10.745,5.008a1.079,1.079,0,0,0,.117.014q.885.062,1.742.062a18.366,18.366,0,0,0,13.491-5.4c3.485-3.483,5.283-8.107,5.347-13.746a1.163,1.163,0,0,0-.009-.161c-.573-4.777-1.72-7.966-3.5-9.75",
    transform: "translate(21.92 16.5)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16.5, -16.5)",
    filter: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.423.862a1.238,1.238,0,0,0-.44-.081A2.141,2.141,0,0,0,196.849,2.9a1.308,1.308,0,0,0-.009.15v26.7L177.017,4.9c-2.562-3.415-3.331-3.923-3.852-4.132a1.24,1.24,0,0,0-.46-.088h-.1a1.238,1.238,0,0,0-.44.081,2.657,2.657,0,0,0-1.516,1.61,1.24,1.24,0,0,0-.085.451v32.42a1.244,1.244,0,0,0,.116.525,2.673,2.673,0,0,0,1.643,1.585,1.253,1.253,0,0,0,.282.032,2.074,2.074,0,0,0,1.911-1.187,1.24,1.24,0,0,0,.131-.553V8.355l20.121,25.106A31.061,31.061,0,0,0,197.2,36.47a1.891,1.891,0,0,0,1.248.871l.069.016a1.222,1.222,0,0,0,.263.028h.3a1.236,1.236,0,0,0,.8-.3,2.065,2.065,0,0,0,.936-1.513V2.934a2.134,2.134,0,0,0-1.4-2.072",
    transform: "translate(21.72 16.38)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16.5, -16.5)",
    filter: "url(#w)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.423.862a1.238,1.238,0,0,0-.44-.081A2.141,2.141,0,0,0,196.849,2.9a1.308,1.308,0,0,0-.009.15v26.7L177.017,4.9c-2.562-3.415-3.331-3.923-3.852-4.132a1.24,1.24,0,0,0-.46-.088h-.1a1.238,1.238,0,0,0-.44.081,2.657,2.657,0,0,0-1.516,1.61,1.24,1.24,0,0,0-.085.451v32.42a1.244,1.244,0,0,0,.116.525,2.673,2.673,0,0,0,1.643,1.585,1.253,1.253,0,0,0,.282.032,2.074,2.074,0,0,0,1.911-1.187,1.24,1.24,0,0,0,.131-.553V8.355l20.121,25.106A31.061,31.061,0,0,0,197.2,36.47a1.891,1.891,0,0,0,1.248.871l.069.016a1.222,1.222,0,0,0,.263.028h.3a1.236,1.236,0,0,0,.8-.3,2.065,2.065,0,0,0,.936-1.513V2.934a2.134,2.134,0,0,0-1.4-2.072",
    transform: "translate(21.72 16.38)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXenonLogo);
export default __webpack_public_path__ + "static/media/xenon_logo.d547280dd3d35577f656ee218199f93d.svg";
export { ForwardRef as ReactComponent };